import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import {Meta} from '@angular/platform-browser';
import {LanguageService} from './language.service';

const TAG_DESCRIPTION = 'description';
const TAG_KEYWORDS = 'keywords';
const SITE_URL = 'https://moony.tips';
const DEFAULT_IMAGE = `${SITE_URL}/assets/images/moon/moon_4.webp`;

@Injectable({
    providedIn: 'root'
})
export class MetaService {

    constructor(
        private meta: Meta,
        @Inject(DOCUMENT) private document: Document,
        private language: LanguageService
    ) {
    }


    updateDescription(description: string) {
        this.meta.updateTag(
            {name: TAG_DESCRIPTION, content: description},
            `name=${TAG_DESCRIPTION}`
        );
    }

    updateKeywords(keywords: string) {
        this.meta.updateTag(
            {name: TAG_KEYWORDS, content: keywords},
            `name=${TAG_KEYWORDS}`
        );
    }

    updateCanonicalUrl(path: string) {
        const localizedPath = this.localizedPath(path);
        const url = this.absoluteUrl(localizedPath);
        let link = this.document.querySelector<HTMLLinkElement>('link[rel="canonical"]');

        if (!link) {
            link = this.document.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.document.head.appendChild(link);
        }

        link.setAttribute('href', url);
        this.updateAlternateLanguageLink('de', this.absoluteUrl(this.germanPath(path)));
        this.updateAlternateLanguageLink('en', this.absoluteUrl(`/en${this.germanPath(path)}`));
        this.updateAlternateLanguageLink('x-default', this.absoluteUrl(this.germanPath(path)));
    }

    updateSocialTags(title: string, description: string, path: string, image: string = DEFAULT_IMAGE) {
        const url = this.absoluteUrl(this.localizedPath(path));

        this.meta.updateTag({property: 'og:title', content: title}, `property='og:title'`);
        this.meta.updateTag({property: 'og:description', content: description}, `property='og:description'`);
        this.meta.updateTag({property: 'og:url', content: url}, `property='og:url'`);
        this.meta.updateTag({property: 'og:image', content: image}, `property='og:image'`);
        this.meta.updateTag({name: 'twitter:card', content: 'summary'}, `name='twitter:card'`);
        this.meta.updateTag({name: 'twitter:title', content: title}, `name='twitter:title'`);
        this.meta.updateTag({name: 'twitter:description', content: description}, `name='twitter:description'`);
        this.meta.updateTag({name: 'twitter:image', content: image}, `name='twitter:image'`);
    }

    private localizedPath(path: string): string {
        if (path.startsWith('http') || path.startsWith('/en/')) {
            return path;
        }

        return this.language.current() === 'en' ? `/en${path}` : path;
    }

    private germanPath(path: string): string {
        return path.startsWith('/en/') ? path.substring(3) : path;
    }

    private updateAlternateLanguageLink(language: string, href: string): void {
        let link = this.document.querySelector<HTMLLinkElement>(`link[rel="alternate"][hreflang="${language}"]`);

        if (!link) {
            link = this.document.createElement('link');
            link.setAttribute('rel', 'alternate');
            link.setAttribute('hreflang', language);
            this.document.head.appendChild(link);
        }

        link.setAttribute('href', href);
    }

    private absoluteUrl(path: string) {
        return path.startsWith('http') ? path : `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
    }
}
